import { createSelector, createStructuredSelector } from "reselect"
import { fromJS } from "immutable"
import constants from "shared/favorites/constants"

export const selectProfileId = (state, props) => props.profileId
export const selectProfileQdt = (state, props) => props.profileQdt

export const favoritesSelector = state => state.favoriteUserActions
const makeFavoritesSelector = key => createSelector(
    favoritesSelector,
    (slice) => {
        if (slice.get(key) === undefined) {
            return undefined
        }
        // if it is immutable, use toJS
        return slice.get(key).toJS
            ? slice.get(key).toJS()
            : slice.get(key)
    }
)

export const selectIsLoadingUserActions = makeFavoritesSelector("isLoadingUserActions")

export const selectFavorites = makeFavoritesSelector("favorites")

// Since we're already showing some bookmarked searches, don't show those in both
// the bookmarks and recents columns.
const filterOutAlreadyBookmarked = (state, recents, favorites) => {
    const getField = userAction => userAction.humanized_text
    const alreadyBookmarked = favorites.map(userAction => getField(userAction))
    return recents.filter(userAction => !alreadyBookmarked.includes(getField(userAction)))
}

export const selectRecents = createSelector(
    favoritesSelector,
    makeFavoritesSelector("recents"),
    selectFavorites,
    (state, recents, favorites) => filterOutAlreadyBookmarked(state, recents, favorites)
)

export const getUserActionTooltip = (userAction) => {
    if (userAction.is_favorited) {
        return constants.favoriteActionTooltip
    }
    return (userAction.safedsearch ? constants.recentSearchTooltip : constants.recentProfileTooltip)
}

export const favoritesConnection = createStructuredSelector({
    isLoadingUserActions: selectIsLoadingUserActions,
    recents: selectRecents,
    favorites: selectFavorites,
    getUserActionTooltip: () => getUserActionTooltip,
})

/* Selectors for favorite/unfavorite button in profiles that can be favorite */
export const selectFavoriteOrRecent = createSelector(
    selectProfileId,
    selectProfileQdt,
    favoritesSelector,
    (profileId, profileQdt, slice) => (
        slice.getIn(["profileFavoriteOrRecent", `${profileQdt}-${profileId}`]) || fromJS({})
    )
)

/**
 * Returns an is_favorited useraction corresponding to given profile if one exists.
 * @return {number|undefined} [id of useraction or undefined]
 */
export const selectIsProfileFavorited = createSelector(
    selectFavoriteOrRecent,
    favoriteOrRecent =>
        Boolean(favoriteOrRecent.get("is_favorited"))
)

export const selectFavoriteOrRecentId = createSelector(
    selectFavoriteOrRecent,
    favoriteOrRecent => favoriteOrRecent.get("id")
)

export const selectIsSubmittingInProfile = createSelector(
    favoritesSelector,
    state => state.get("isSubmitting")
)

export const favoritesActionButtonConnection = createStructuredSelector({
    favoriteOrRecentId: selectFavoriteOrRecentId,
    isProfileFavorited: selectIsProfileFavorited,
    isSubmitting: selectIsSubmittingInProfile
})
